import { useState } from "react";
import { Star, TrendingUp, Users } from "lucide-react";
import { Reveal } from "./Reveal";

export const RoiWidget = () => {
  const [clients, setClients] = useState(80);
  const reviews = Math.round(clients * 30 * 0.12);

  return (
    <section data-testid="roi-widget" className="bg-[#0F172A] py-24 sm:py-32">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 lg:grid-cols-2">
        <Reveal>
          <span className="rounded-full bg-white/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-[#FBBC04]">
            Fai due conti
          </span>
          <h2 className="font-display mt-5 text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Quante recensioni stai lasciando sul tavolo?
          </h2>
          <p className="mt-4 max-w-md text-base leading-relaxed text-slate-400 sm:text-lg">
            Muovi il cursore: con una stima prudente del 12% di clienti che fanno tap, ecco quante recensioni in più
            potresti raccogliere ogni mese con TapGoogle.com.
          </p>
          <div className="mt-8">
            <label htmlFor="clients-slider" className="flex items-center gap-2 text-sm font-medium text-slate-300">
              <Users className="h-4 w-4 text-[#4285F4]" /> Clienti al giorno nel tuo locale
            </label>
            <input
              id="clients-slider"
              data-testid="roi-slider"
              type="range"
              min="10"
              max="500"
              step="10"
              value={clients}
              onChange={(e) => setClients(Number(e.target.value))}
              className="mt-4 w-full accent-[#4285F4]"
            />
            <div className="mt-2 flex justify-between text-xs text-slate-500">
              <span>10</span>
              <span className="font-display text-lg font-bold text-white">{clients} clienti/giorno</span>
              <span>500</span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="rounded-[2rem] border border-white/10 bg-white/5 p-8 backdrop-blur sm:p-10">
            <div className="flex items-end gap-3">
              <span data-testid="roi-result" className="font-display text-6xl font-extrabold tracking-tight text-white sm:text-7xl">
                +{reviews}
              </span>
              <span className="pb-2 text-sm font-medium text-slate-400">recensioni<br />al mese</span>
            </div>
            <div className="mt-4 flex gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-6 w-6 fill-[#FBBC04] text-[#FBBC04]" />
              ))}
            </div>
            <div className="mt-8 flex items-start gap-3 rounded-2xl bg-[#4285F4]/15 p-5">
              <TrendingUp className="mt-0.5 h-5 w-5 shrink-0 text-[#FBBC04]" />
              <p className="text-sm leading-relaxed text-slate-300">
                Un flusso costante di recensioni fresche migliora il posizionamento su Google Maps e rende la tua
                scheda la scelta più naturale della zona.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
